import React from "react";
import Routes from "./Routes";
import CustomCursor from "./components/CustomCursor"; 
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <>
    <HelmetProvider>
      <CustomCursor />  
      <Routes />
    </HelmetProvider>
    </>
  );
}

export default App;
